import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-nav',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav/view.scss */
/* src/app/component.nav/view.scss: no such file or directory */`],
})
export class ComponentNavComponent implements OnInit {
    @Input() title: any;

    public async ngOnInit() {
    }
}

export default ComponentNavComponent;